import { BrowserRouter, useRoutes } from 'react-router-dom';
import { routes } from './router';
import { Providers } from './providers';
import { BackendHealthNotice } from '../components/common/BackendHealthNotice';
import '../styles/theme.css';
import '../index.css';

function AppRoutes() {
  return useRoutes(routes);
}

/**
 * Root App component.
 *
 * Structure:
 *   Providers (context)
 *     → BackendHealthNotice (offline banner for localhost dev)
 *     → BrowserRouter
 *       → AppRoutes (route tree)
 */
function App() {
  return (
    <Providers>
      <BackendHealthNotice />
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <AppRoutes />
      </BrowserRouter>
    </Providers>
  );
}

export default App;
